<template>
  <v-container
    id="movePlatServices"
    fluid
    tag="section"
  >
    <v-row
      class="d-flex"
    >
      <v-col
        md="6"
        cols="12"
      >
        <base-tile-card>
          <template v-slot:heading>
            <div>
              Source Account
            </div>
          </template>
          <v-row
            class="mx-3 px-2"
          >
            <v-text-field
              v-model="sourceCustomerId"
              label="Source Account Id"
            >
              <template v-slot:append>
                <v-btn
                  tile
                  color="primary"
                  @click="doGetSourceCustomer"
                >
                  Find
                </v-btn>
              </template>
            </v-text-field>
          </v-row>
          <v-row
            v-if="sourceCustomer.id > 0"
            class="mx-3"
          >
            <v-col
              cols="4"
              class="section-subheader"
            >
              Name:
            </v-col>
            <v-col
              cols="8"
              class="section-text"
            >
              {{ sourceCustomer.name }}
            </v-col>
            <v-col
              v-for="(type, name) in sourceCustomer.services"
              :key="name"
              cols="12"
            >
              <v-card
                class="pa-1"
              >
                <h1>Service: {{ name }} [{{type.length}}]</h1>
                <v-divider></v-divider>
                <v-row
                  class="d-flex pa-2"
                >
                  <v-card
                    v-for="(record, i) of type"
                    :key="i"
                    class="mx-2 pa-1 card-full-width"
                  >
                    <h1>{{ record.s_name }}</h1>
                    <v-btn
                      v-if="selectedService.s_num === 0 || selectedService.s_num !== record.s_num"
                      tile
                      color="primary"
                      @click="doSelectService(record)"
                    >
                      Select
                    </v-btn>
                    <v-btn
                      v-else-if="selectedService.s_num === record.s_num"
                      tile
                      color="secondary"
                    >
                      SELECTED
                    </v-btn>
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          CRID
                        </v-list-item-content>
                        <v-list-item-action>
                          {{ record.crid }}
                        </v-list-item-action>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          s_num
                        </v-list-item-content>
                        <v-list-item-action>
                          {{ record.s_num }}
                        </v-list-item-action>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          struct_id
                        </v-list-item-content>
                        <v-list-item-action>
                          {{ record.s_struct_id }}
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                    <v-card
                      style="width: 280px"
                    >
                      <h3>Details</h3>
                      <v-list>
                        <v-list-item
                          v-for="(detail, r) in record.details"
                          :key="r"
                        >
                          <v-list-item-content>
                            {{ r }}
                          </v-list-item-content>
                          <v-list-item-action>
                            {{ detail }}
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-card>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </base-tile-card>
      </v-col>
      <v-col
        md="6"
        cols="12"
      >
        <base-tile-card>
          <template v-slot:heading>
            <div>
              Target Account
            </div>
          </template>
          <v-row
            class="mx-3 px-2"
          >
            <v-text-field
              v-model="targetCustomerId"
              label="Source Account Id"
            >
              <template v-slot:append>
                <v-btn
                  tile
                  color="primary"
                  @click="doGetTargetCustomer"
                >
                  Find
                </v-btn>
              </template>
            </v-text-field>
          </v-row>
          <v-row
            v-if="targetCustomer.id > 0"
            class="mx-3"
          >
            <v-col
              cols="4"
              class="section-subheader"
            >
              Name:
            </v-col>
            <v-col
              cols="8"
              class="section-text"
            >
              {{ targetCustomer.name }}
            </v-col>
            <v-col cols="12">
              <h1>Rates</h1>
              <v-card
                class="mx-2 pa-1 card-full-width"
                v-for="(rate, i) in targetCustomer.rates"
                :key="rate + '-' + i"
              >
                <h1>{{ rate.rg_name }}</h1>
                <v-btn
                  v-if="selectedService.s_num > 0"
                  tile
                  color="primary"
                  @click="doStartMoveServices(rate)"
                >
                  Move {{ selectedService.s_name }}
                </v-btn>
                <v-btn
                  v-else
                  tile
                  color="secondary"
                >
                  Select a service to continue
                </v-btn>
                <v-divider></v-divider>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      RGID
                    </v-list-item-title>
                    <v-list-item-action>
                      {{ rate.rgid }}
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      CRID
                    </v-list-item-title>
                    <v-list-item-action>
                      {{ rate.crid }}
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col
              v-for="(type, name) in targetCustomer.services"
              :key="name"
              cols="12"
            >

              <v-card
                class="pa-1"
              >
                <h1>Service: {{ name }} [{{type.length}}]</h1>
                <v-divider></v-divider>
                <v-row
                  class="d-flex"
                >
                  <v-card
                    v-for="(record, i) of type"
                    :key="i"
                    class="mx-2 pa-1 card-full-width"
                  >
                    Crid: {{ record.crid }}
                  </v-card>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </base-tile-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        md="6"
        cols="12"
      >
        <base-tile-card>
          <template v-slot:heading>
            <div>
              Copy Pictures
            </div>
          </template>
          <v-row
            v-if="sourceCustomerId > 0 && targetCustomerId > 0"
            class="mx-3 px-2"
          >
            <a
              :href="powUrl + '/copy_pictures.php?src=' + sourceCustomerId + '&tar=' + targetCustomerId"
              target="_blank"
            >
              Copy Pictures with POW
            </a>
          </v-row>
          <v-row
            v-else
          >
            Please set the source and target customers
          </v-row>

        </base-tile-card>
      </v-col>
      <v-col
        md="6"
        cols="12"
      >
        <base-tile-card>
          <template v-slot:heading>
            <div>
              Move Equipment
            </div>
          </template>
          <v-row
            v-if="sourceCustomerId > 0 && targetCustomerId > 0"
            class="mx-3 px-2"
          >
            <a
              :href="powUrl + '/move_equipment.php?src=' + sourceCustomerId + '&tar=' + targetCustomerId"
              target="_blank"
            >
              Move Equipment with POW
            </a>
          </v-row>
          <v-row
            v-else
          >
            Please set the source and target customers
          </v-row>

        </base-tile-card>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog
        v-model="dialogConfirmMove"
        persistent
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">
            Confirm Move Service
          </v-card-title>
          <v-card-text>Confirm moving {{ selectedService.s_name }} to {{ selectedRate.rg_name }}</v-card-text>
 <!--     Errors-->
          <v-card
            v-if="moveServiceErrors.length > 0"
            flat
            class="mr-7 card-full-width"
          >
            <v-alert
              v-for="(e, i) in moveServiceErrors"
              :key="i"
              type="error"
            >
              {{ e }}
            </v-alert>
          </v-card>
          <v-card
            v-if="serviceMoved"
            flat
            class="mx-3 pa-2"
          >
            <v-alert
              type="success"
            >
              Service successfully moved!
            </v-alert>
          </v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!serviceMoved"
              color="green darken-1"
              text
              @click="dialogConfirmMove = false"
            >
              Cancel
            </v-btn>
            <v-btn
              v-if="!serviceMoved"
              color="green darken-1"
              text
              :loading="isMovingService"
              @click="doMoveServices"
            >
              Confirm
            </v-btn>
            <v-btn
              v-if="serviceMoved"
              color="green darken-1"
              text
              @click="resetMoveForm"
            >
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'
  // import moment from '../../../assets/js/moment.min'

  import PowCustomerService from '../../../services/pow-customer.service'
  import {
    _PROCESS_ERROR,
  } from '../../../store/actions.types'
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'MovePlatServices',
    components: {
      // PowInvoiceDetails: () => import('@/components/pow/InvoiceDetails'),
    },
    mixins: [basicMixin],

    data () {
      return {
        tab: 0,
        dialogConfirmMove: false,
        isMovingService: false,
        serviceMoved: false,
        selectedServiceInit: {
          s_num: 0,
        },
        selectedService: {
          s_num: 0,
        },
        selectedRate: {},
        sourceCustomerId: 0,
        sourceCustomer: {
          id: 0,
          name: '',
          active: '',
          attn: '',
          addr1: '',
          city: '',
          state: '',
          phone: '',
        },
        targetCustomerId: 0,
        targetCustomer: {
          id: 0,
          name: '',
          active: '',
          attn: '',
          addr1: '',
          city: '',
          state: '',
          phone: '',
        },
        moveServiceErrors: [],
      }
    },
    watch: {
      // sourceCustomerId (n, o) {
      //   this.$router.query.src = n
      // },
      // targetCustomerId (n, o) {
      //   this.$router.query.tar = n
      // },
    },
    computed: {
      powUrl: {
        get () {
          return `${process.env.VUE_APP_API_POW_URL}`
        },
      },

    },
    async created () {
      console.log('page loaded')
      // console.log('QS:', this.$route.query)
      if (this.$route.query && this.$route.query.src) {
        try {
          this.sourceCustomerId = parseInt(this.$route.query.src)
        } catch (e) {
          console.log(e)
        }
      }
      if (this.$route.query && this.$route.query.tar) {
        try {
          this.targetCustomerId = parseInt(this.$route.query.tar)
        } catch (e) {
          console.log(e)
        }
      }
      if (this.sourceCustomerId > 0) {
        this.doGetSourceCustomer()
      }
      if (this.targetCustomerId > 0) {
        this.doGetTargetCustomer()
      }
    },
    mounted () {
    },
    methods: {
      ...mapActions({
        processError: _PROCESS_ERROR,
      }),
      async doGetSourceCustomer () {
        const { data } = await PowCustomerService.get(this.sourceCustomerId)
        console.log(data)
        this.sourceCustomer = data
        this.sourceCustomerId = data.id
        this.changeQuery('src', data.id)
      },
      async doGetTargetCustomer () {
        const { data } = await PowCustomerService.get(this.targetCustomerId)
        console.log(data)
        this.targetCustomer = data
        this.targetCustomerId = data.id
        this.changeQuery('tar', data.id)
      },
      doStartMoveServices (rate) {
        this.selectedRate = rate
        this.dialogConfirmMove = true
        this.isMovingService = false
        this.moveServiceErrors = []
      },
      async doMoveServices () {
        const rate = this.selectedRate
        const svc = this.selectedService
        try {
          this.isMovingService = true
          const { data } = await PowCustomerService.moveService({
            data_id: svc.s_num,
            svc_type: svc.s_svc_id,
            cust_id: rate.custid,
            crid: rate.crid,
          })
          console.log('moveService Response:', data)
          this.selectedService = this.selectedServiceInit
          await this.doGetSourceCustomer()
          await this.doGetTargetCustomer()
          this.isMovingService = false
          this.serviceMoved = true
        } catch (e) {
          const processedError = await this.processError(e)
          this.moveServiceErrors = processedError.problems
          console.log(processedError)
          this.isMovingService = false
        }
      },
      doSelectService (svc) {
        this.selectedService = svc
        console.log('Selected svc:', svc)
      },
      onSelectedServiceChange () {
        console.log('Selected services:', this.selectedServices)
      },
      resetMoveForm () {
        this.selectedService = this.selectedServiceInit
        this.isMovingService = false
        this.serviceMoved = false
        this.dialogConfirmMove = false
      },
    },
  }
</script>
<style scoped>
  .list-lbl {
    width: 220px;
    font-weight: bold;
  }
</style>
